/**
 * Client-side authentication helper utilities
 */

/**
 * Hashes a string identifier (like a user ID) for use as a secure channel name.
 * @param identifier The string to hash.
 * @returns A SHA-256 hash as a hex string.
 */
export async function hashIdentifier(identifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(identifier);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
}
